"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketNotificationConfigurationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketNotificationConfigurationOutput.js.map